import { useEffect, useState } from "react"
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext"
import { $generateNodesFromDOM } from "@lexical/html"
import { $getRoot } from "lexical"

interface ISetInitialDataPlugin {
  initialData: string | undefined
  hasFocus: boolean
  prevData: string
  isModalOpen: boolean
}

const SetInitialDataPlugin = ({
  initialData,
  hasFocus,
  prevData,
  isModalOpen,
}: ISetInitialDataPlugin) => {
  const [editor] = useLexicalComposerContext()
  const [initialStateSet, setInitialStateSet] = useState<boolean>(false)

  useEffect(() => {
    // in case updated editor data state is coming from outside, we need to reset the initial state flag to allow re-setting the editor content,
    // but only when the editor is not focused (to avoid overwriting user changes)
    if (!hasFocus && initialData !== prevData && !isModalOpen) {
      setInitialStateSet(false)
    }
  }, [hasFocus, initialData, prevData])

  useEffect(() => {
    if (initialData && !initialStateSet) {
      editor.update(() => {
        const root = $getRoot()
        root.clear()
        const parser = new DOMParser()

        const dom = parser.parseFromString(initialData, "text/html")

        root.append(...$generateNodesFromDOM(editor, dom.body))
        setInitialStateSet(true)
      })
    }
  }, [initialData, initialStateSet])

  return null
}

export default SetInitialDataPlugin
